module.exports = __webpack_public_path__ + "static/media/alignerr_logo.eff86162.png";